import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// OS Buddy brand font (self-hosted variable font, weights 100–900, font-display: swap)
import '@fontsource-variable/outfit';
import { App } from './App';
import { startErrorTracking } from './lib/errorTracking';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

// GlitchTip (#3620): off unless staff-api hands out a browser DSN. Not awaited:
// the app never waits for error tracking.
void startErrorTracking('staff-portal');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
